var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { VuexModule, Module, Mutation, Action, } from 'vuex-module-decorators';
import { firestore } from '../db';
// NOTE: Vuex Typescript reference implementation
// Ref: https://blog.logrocket.com/how-to-write-a-vue-js-app-completely-in-typescript/
var Main = /** @class */ (function (_super) {
    __extends(Main, _super);
    function Main() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.authIdState = null;
        _this.db = firestore();
        return _this;
    }
    Main.prototype.setAuthId = function (id) {
        this.authIdState = id;
    };
    Object.defineProperty(Main.prototype, "authId", {
        get: function () {
            return this.authIdState;
        },
        enumerable: false,
        configurable: true
    });
    Main.prototype.signIn = function (uid) {
        this.context.commit('setAuthId', uid);
    };
    Main.prototype.signOut = function () {
        this.context.commit('setAuthId', null);
    };
    __decorate([
        Mutation
    ], Main.prototype, "setAuthId", null);
    __decorate([
        Action
    ], Main.prototype, "signIn", null);
    __decorate([
        Action
    ], Main.prototype, "signOut", null);
    Main = __decorate([
        Module({ namespaced: true })
    ], Main);
    return Main;
}(VuexModule));
export default Main;
